import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@mui/material';

const LoginButton = ({ fullWidth }) => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  if (!isAuthenticated) {
    return (
      <Button 
        color="inherit" 
        onClick={() => loginWithRedirect()}
        fullWidth={fullWidth}
      >
        Log In
      </Button>
    );
  }
  return null;
};

export default LoginButton;